import JumboScrollbar from '@jumbo/components/JumboScrollbar';
import { Card } from '@mui/material';
import { dshCardHeight, dshCardScrollHeight } from 'config';
import DshBoxTitle from '../Box/DshBoxTitle';
import AgendaReviewListTable from '../Table/AgendaReviewListTable';


function ReviewStatusCard({ reviewsOfTheMeeting, setReviewInputStatus, title, scroll = true }) {

    return (
        <Card

            sx={{
                m: 0,
                p: '10px',
                marginBottom: 0,
                minHeight: `${dshCardHeight}`,
                // height: `${dshPreviousCardHeight}`,

            }}
        >

            {title === "Öneri Durumu" ? (
                <DshBoxTitle color="error" title={title} />
            ) : (
                <DshBoxTitle color="primary" title={title} />
            )}



            {scroll ? (
                <JumboScrollbar
                    autoHeight
                    autoHeightMax={`${dshCardScrollHeight}`}
                    autoHide
                    autoHideDuration={200}
                    autoHideTimeout={500}
                >


                    <AgendaReviewListTable agendaReviews={reviewsOfTheMeeting} setReviewInputStatus={setReviewInputStatus} otherScroll={true}></AgendaReviewListTable>

                </JumboScrollbar>
            ) : (

                <AgendaReviewListTable agendaReviews={reviewsOfTheMeeting} setReviewInputStatus={setReviewInputStatus} otherScroll={'none'} ></AgendaReviewListTable>


            )}

        </Card >
    );
};

ReviewStatusCard.defaultProps = {
    setVoteInputStatus: undefined,
};
export default ReviewStatusCard


